import accessMethods from './accessMethods'
import components from './components'
import contextMenuGen from './contextMenuGen'
import noticeGens from './noticeGens'
import propGens from './propGens'

export default {
  accessMethods,
  components,
  contextMenuGen,
  noticeGens,
  propGens
}
